// import React, { useState } from "react";
// import toast from "react-hot-toast";

// const AddMedicineModal = ({ isOpen, onClose, onSave }) => {
//   const [data, setData] = useState({
//     medicine_name: "",
//     item_code: "",
//     batch_no: "",
//     weight: "",
//     box_quantity: "",
//     unit_price: 0.00,
//     pack_quantity: "",
//   });

//   if (!isOpen) return null;

//   const handleChange = (e) => {
//     setData({ ...data, [e.target.name]: e.target.value });
//   };

//   const handleSave = () => {
//     if (!data.medicine_name) {
//       toast.error("Medicine Name is required");
//       return;
//     }
//     if (!data.item_code) {
//       toast.error("Item Code is required");
//       return;
//     }
//     if (!data.batch_no) {
//       toast.error("Batch No. is required");
//       return;
//     }
//     if (!data.weight) {
//       toast.error("Weight Code is required");
//       return;
//     }
//     if (!data.box_quantity) {
//       toast.error("Box Quantity is required");
//       return;
//     }
//     if (!data.pack_quantity) {
//       toast.error("Pack Quantity is required");
//       return;
//     }
//     onSave(data);
//     onClose();
//     toast.success("Medicine Added Successfully");
//     setTimeout(() => {
//       window.location.reload();
//     }, 500);
//   };

//   return (
//     <div
//       className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 ml-[240px]"
//     >
//       <div
//         className="bg-white px-8 py-6 rounded-2xl w-[70%] shadow-lg"
//         onClick={(e) => e.stopPropagation()}
//       >
//         <div className="flex justify-end">
//           <button
//             onClick={onClose}
//             className="font-semibold text-md bg-red-600 px-[7px] rounded-full text-white"
//           >
//             ×
//           </button>
//         </div>

//         <h2 className="text-lg text-center font-bold text-primary mb-4">
//           Add New Medicine
//         </h2>

//         <div className="grid grid-cols-3 gap-4">
//           <input
//             type="text"
//             name="medicine_name"
//             onChange={handleChange}
//             className="bg-gray-50 px-3 py-2 text-sm border-b-2 rounded-lg focus:outline-none focus:border-primary"
//             placeholder="Medicine Name"
//           />
//           <input
//             type="text"
//             name="item_code"
//             onChange={handleChange}
//             className="bg-gray-50 px-3 py-2 text-sm border-b-2 rounded-lg focus:outline-none focus:border-primary"
//             placeholder="Item Code"
//           />

//           <input
//             type="text"
//             name="batch_no"
//             onChange={handleChange}
//             className="bg-gray-50 px-3 py-2 text-sm border-b-2 rounded-lg focus:outline-none focus:border-primary"
//             placeholder="Batch No"
//           />
//           <input
//             type="text"
//             name="weight"
//             onChange={handleChange}
//             className="bg-gray-50 px-3 py-2 text-sm border-b-2 rounded-lg focus:outline-none focus:border-primary"
//             placeholder="Weight"
//           />
//           <input
//             type="number"
//             name="box_quantity"
//             min="0"
//             onChange={handleChange}
//             onKeyDown={(e) => {
//               if (e.key === '-' || e.key === 'e') {
//                 e.preventDefault();
//               }
//             }}
//             className="bg-gray-50 px-3 py-2 text-sm border-b-2 rounded-lg focus:outline-none focus:border-primary"
//             placeholder="Box Quantity"
//           />
//           <input
//             type="number"
//             name="pack_quantity"
//             min="0"
//             onChange={handleChange}
//             onKeyDown={(e) => {
//             if (e.key === '-' || e.key === 'e') {
//               e.preventDefault();
//             }
//             }}
//             className="bg-gray-50 px-3 py-2 text-sm border-b-2 rounded-lg focus:outline-none focus:border-primary"
//             placeholder="Pack Quantity"
//           />
//         </div>

//         <div className="flex justify-center mt-6">
//           <button
//             onClick={handleSave}
//             className="bg-primary text-white px-6 py-2 rounded-lg font-semibold hover:bg-opacity-90 transition"
//           >
//             Save Product
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AddMedicineModal;

import React, { useState } from "react";
import toast from "react-hot-toast";
import {
  MdLocalPharmacy,
  MdQrCode,
  MdNumbers,
  MdScale,
  MdInventory2,
  MdClose,
  MdCheck,
} from "react-icons/md";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const FIELDS = [
  {
    name: "medicine_name",
    label: "Medicine Name",
    placeholder: "e.g. Panadol 500mg",
    type: "text",
    icon: MdLocalPharmacy,
  },
  {
    name: "item_code",
    label: "Item Code",
    placeholder: "e.g. MED-001",
    type: "text",
    icon: MdQrCode,
  },
  {
    name: "batch_no",
    label: "Batch No.",
    placeholder: "e.g. BT-2024-09",
    type: "text",
    icon: MdNumbers,
  },
  {
    name: "weight",
    label: "Weight",
    placeholder: "e.g. 500mg",
    type: "text",
    icon: MdScale,
  },
  {
    name: "box_quantity",
    label: "Box Quantity",
    placeholder: "0",
    type: "number",
    icon: MdInventory2,
    min: "0",
  },
  {
    name: "pack_quantity",
    label: "Pack Quantity",
    placeholder: "0",
    type: "number",
    icon: MdInventory2,
    min: "0",
  },
];

const AddMedicineModal = ({ isOpen, onClose, onSave }) => {
  const [data, setData] = useState({
    medicine_name: "",
    item_code: "",
    batch_no: "",
    weight: "",
    box_quantity: "",
    unit_price: 0.0,
    pack_quantity: "",
  });
  const [saving, setSaving] = useState(false);

  if (!isOpen) return null;

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    for (const field of FIELDS) {
      if (!data[field.name]) {
        toast.error(`${field.label} is required`);
        return;
      }
    }
    setSaving(true);
    setTimeout(() => {
      onSave(data);
      onClose();
      toast.success("Medicine Added Successfully");
      setSaving(false);
      setTimeout(() => window.location.reload(), 500);
    }, 400);
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center ml-[240px] bg-black bg-opacity-40 backdrop-blur-sm"
     
    >
      <div
        className="bg-white rounded-2xl w-[90%] max-w-[680px] shadow-2xl overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* ── Header ── */}
        <div className="flex items-center justify-between px-6 py-5 bg-primary">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-xl bg-white bg-opacity-20 flex items-center justify-center">
              <MdLocalPharmacy size={17} className="text-white" />
            </div>
            <div>
              <h2 className="text-white text-lg font-bold leading-tight">
                Add New Medicine
              </h2>
              <p className="text-green-100 text-[11px] mt-0.5">
                Fill in all required fields to add a medicine
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-xl bg-white bg-opacity-20 flex items-center justify-center text-white hover:bg-opacity-30 transition-colors"
          >
            <MdClose size={17} />
          </button>
        </div>

        {/* ── Body ── */}
        <div className="px-6 py-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            {FIELDS.map(({ name, label, placeholder, type, icon: Icon, min }) => (
              <div key={name}>
                <label className="block text-[11px] font-semibold tracking-wider uppercase text-gray-500 mb-1.5">
                  {label} <span className="text-red-400">*</span>
                </label>
                <div className="relative flex items-center">
                  <Icon
                    size={15}
                    className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"
                  />
                  <input
                    type={type}
                    name={name}
                    placeholder={placeholder}
                    min={min}
                    onChange={handleChange}
                    onKeyDown={
                      type === "number"
                        ? (e) => {
                            if (e.key === "-" || e.key === "e") e.preventDefault();
                          }
                        : undefined
                    }
                    className="w-full bg-gray-50 border border-gray-200 rounded-xl pl-9 pr-3 py-2.5 text-sm text-gray-800 placeholder-gray-300 outline-none focus:border-primary focus:ring-2 focus:ring-primary focus:ring-opacity-20 transition-all"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ── Footer ── */}
        <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex items-center justify-between">
          <p className="text-[11px] text-gray-400">
            <span className="text-red-400 font-bold">*</span> Required fields
          </p>
          <div className="flex gap-3">
            <button
              onClick={onClose}
              className="px-5 py-2.5 rounded-xl text-sm font-semibold text-gray-500 bg-white border border-gray-200 hover:bg-gray-100 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleSave}
              disabled={saving}
              className="flex items-center gap-2 px-6 py-2.5 rounded-xl text-sm font-semibold text-white bg-primary hover:bg-opacity-90 transition-all disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {saving ? (
                <>
                  <AiOutlineLoading3Quarters size={14} className="animate-spin" />
                  Saving…
                </>
              ) : (
                <>
                  <MdCheck size={15} />
                  Save Medicine
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddMedicineModal;